// src/components/ReadyToGradeModal.js
import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

const ReadyToGradeModal = ({ show, onClose, data = [] }) => (
	<Modal
		show={show}
		onHide={onClose}
		size="lg"
		centered
		scrollable /* enable scroll inside the modal body */
	>
		<Modal.Header closeButton>
			<Modal.Title>Core Comps Ready to Submit</Modal.Title>
		</Modal.Header>
		<Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
			{data.length === 0 ? (
				<p>No core competencies are ready for trainer approval.</p>
			) : (
				<Table striped bordered size="sm">
					<thead>
						<tr>
							<th>Alias</th>
							<th>Core&nbsp;Comp</th>
							<th>Site</th>
						</tr>
					</thead>
					<tbody>
						{data.map((r, idx) => (
							<tr key={idx}>
								<td>{r.alias}</td>
								<td>{r.core_comp_code}</td>
								<td>{r.site}</td>
							</tr>
						))}
					</tbody>
				</Table>
			)}
		</Modal.Body>
		<Modal.Footer>
			<Button variant="secondary" onClick={onClose}>
				Close
			</Button>
		</Modal.Footer>
	</Modal>
);

export default ReadyToGradeModal;
